
/* eslint-disable */ 
import Fetch from "./Fetch";
const executeRecaptcha = async () => {
    let response = await Fetch('service/config/')
    if (response.success) {
        return new Promise((resolve, reject) => {
            grecaptcha.ready(() => {
                grecaptcha.execute(response.data['recaptcha-key'], {
                        action: 'submit'
                    })
                    .then((token) => {
                        resolve(token);
                    })
                    .catch((error) => {
                        console.error('recaptcha test failed', error);
                        reject(error);
                    });
            });
        });
    }
};

export default executeRecaptcha;